import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";


import { getFundNoRiskBuyOrderTable, NoRiskTradeInputDTO } from "src/Requests/fundNoRiskTask";

interface IProps {
  id:number;
}
const FundNoRiskBuyOrderTable: React.FC<IProps> = ({
    id
}) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
      
          tableBoxClassName="!max-h-[800px]"
          
        />
      )}
      initialSearchParameters={ {taskId:id} as NoRiskTradeInputDTO} 
      getDataTable={getFundNoRiskBuyOrderTable}      
    />
  );
};

export default FundNoRiskBuyOrderTable;